<script setup>

</script>
<template>
<i class="comm-icon">
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path d="M6 5L9.5 8.5L6 12" stroke="#B0B0B0" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</i>
</template>
<style scoped>

</style>